import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useConfig } from '../context/ConfigContext';

const Home = () => {
    const navigate = useNavigate();
    const { config } = useConfig();

    // Default premium menu buttons as shown in Mockup 1, but with completely dynamic styling
    // based on administrative visual identity configurations
    const primaryColor = config?.primaryColor || "#0a58ca";
    const secondaryColor = config?.secondaryColor || "#ffa800";

    const defaultButtons = [
        {
            label: "AGENDA",
            path: "/agenda",
            color: primaryColor
        },
        {
            label: "SPEAKERS",
            path: "/speakers",
            color: secondaryColor
        },
        {
            label: "PREGUNTAS AL EXPOSITOR",
            path: "/questions-expert",
            color: primaryColor
        },
        {
            label: "CARTA LOGÍSTICA",
            path: "/welcome",
            color: secondaryColor,
            isExternal: true
        }
    ];

    // Use configurable buttons if defined in configs, otherwise fallback to dynamically styled defaults
    const menuButtons = config?.home_buttons || defaultButtons;

    // Filter buttons based on whether their corresponding module is enabled in the admin pageDesigns config
    const activeButtons = menuButtons.filter(btn => {
        let key = null;
        if (btn.path.includes('agenda')) key = 'agenda';
        else if (btn.path.includes('speakers')) key = 'speakers';
        else if (btn.path.includes('questions-expert')) key = 'questions_private';
        else if (btn.path.includes('welcome')) key = 'welcome';

        if (key) {
            const design = config?.pageDesigns?.[key];
            if (design && design.enabled === false) return false;
        }
        return true;
    });

    const handleButtonClick = (btn) => {
        if (btn.isExternal || btn.path.startsWith('http')) {
            window.open(btn.path, '_blank', 'noopener,noreferrer');
        } else {
            navigate(btn.path);
        }
    };

    return (
        <div className="flex flex-col items-center justify-start min-h-[75vh] w-full relative z-10 select-none animate-fadeIn">
            {/* Main Navigation Menu Buttons Container */}
            {/* The vertical placement is calculated to leave space for the artist header logo and the perspective art gallery image at the bottom */}
            <div className="w-full max-w-sm px-6 flex flex-col gap-5 items-center mt-8 mb-8">
                {activeButtons.map((btn, idx) => {
                    // Settle exact button color: if it maps to previous static values, replace with the dynamic configurations
                    let activeBtnColor = btn.color;
                    if (btn.color === "#0a58ca") activeBtnColor = primaryColor;
                    if (btn.color === "#ffa800") activeBtnColor = secondaryColor;

                    return (
                        <button
                            key={idx}
                            onClick={() => handleButtonClick(btn)}
                            style={{ backgroundColor: activeBtnColor }}
                            className="w-full text-white py-4 px-6 rounded-lg font-black uppercase tracking-widest text-[14px] sm:text-[16px] shadow-[0_10px_20px_rgba(0,0,0,0.15)] hover:scale-[1.03] active:scale-95 transition-all duration-300 text-center"
                        >
                            {btn.label}
                        </button>
                    );
                })}
            </div>
            <div className="w-full flex justify-center mt-2 pb-2 pointer-events-none">
                <img src={`https://ftp.pcnpublicidad.com/amgen/titulo2.png?v=${Date.now()}`} alt="Sponsor" className="w-[85%] max-w-[300px] object-contain drop-shadow-md" />
            </div>
            {/* Gallery perspective image placed inline instead of fixed background */}
            <div className="w-full pointer-events-none mt-2 relative -mx-4 sm:-mx-6 max-w-[100vw] overflow-hidden flex justify-center">
                <img 
                    src={window.innerWidth < 640 ? "https://ftp.pcnpublicidad.com/amgen/cel_abajo.png" : "https://ftp.pcnpublicidad.com/amgen/web_abajo.png"} 
                    alt="Gallery Background" 
                    className="w-full object-cover object-top" 
                />
            </div>
        </div>
    );
};

export default Home;
